/**
 * Preview My Website – single URL, content varies by plan (free | economy | premium | elite).
 * Route: /preview-my-website?plan=free|economy|premium|elite
 */

import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import FreePreview from "./website-preview/FreePreview";
import EconomyPreview from "./website-preview/EconomyPreview";
import PremiumPreview from "./website-preview/PremiumPreview";
import ElitePreview from "./website-preview/ElitePreview";
import { BackButton } from "@/components/navigation/BackButton";

const PLAN_COMPONENTS = {
  free: FreePreview,
  economy: EconomyPreview,
  premium: PremiumPreview,
  elite: ElitePreview,
} as const;

type PlanKey = keyof typeof PLAN_COMPONENTS;

function useIsMobile() {
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth <= 768);
    check();
    window.addEventListener("resize", check);
    return () => window.removeEventListener("resize", check);
  }, []);
  return isMobile;
}

export function PreviewMyWebsitePage() {
  const [searchParams] = useSearchParams();
  const planParam = searchParams.get("plan")?.toLowerCase() || "free";
  const plan: PlanKey =
    planParam in PLAN_COMPONENTS ? (planParam as PlanKey) : "free";
  const isMobile = useIsMobile();
  const PreviewComponent = PLAN_COMPONENTS[plan];

  return (
    <div className="h-screen flex flex-col bg-[#0B0B0D] overflow-hidden">
      <div className="flex-shrink-0 z-50 flex items-center gap-2 bg-[#0B0B0D]/90 backdrop-blur border-b border-[#2C2C2E] px-4 py-2">
        <BackButton fallbackRoute="/user-home" />
        <span className="text-white font-medium capitalize">
          Preview: {plan}
        </span>
      </div>
      <div data-ptr-root className="flex-1 overflow-y-auto overflow-x-hidden">
        <PreviewComponent isMobile={isMobile} />
      </div>
    </div>
  );
}

export default PreviewMyWebsitePage;
